import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { OtherTransactionsStyles } from './OtherTransactionsStyles'
import * as OrderActions from "../../actions/othertransactions/OrderActions"
import { bindActionCreators } from 'redux'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { formatNumber } from "../common/Utils";

const OtherTransactionsDashboard = ({ classes, ...props }) => {
    const history = useHistory()
    const { match: { params } } = props;
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()

    useEffect(() => {
        handleOpenBackdrop()
    
        props.actions.fetch_Dashboard(props.userLanguage, props.userToken, params.branchOfficeId, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        props.navigationActions.clean_routes()
        const newRoute = {
            path: '/othertransactions',
            linkLegend: t('OtherTransactions'),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)

    }, [t]) 

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = (resp) => {
        if(resp?.error)
            Modal.error({
                title: 'Error',
                content: resp.errorStr
            })
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 404:
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <br />
                        <h5>{t('OtherTransactions')}</h5>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Card className={classes.borderRadius}>
                                <CardActionArea disabled={false} component={RouterLink} to={`/othertransactions/listOrders/${params.branchOfficeId}`}>
                                    <CardHeader className={classes.cardHeader}
                                        title={t(`OrderDashboard.Orders`)}
                                        titleTypographyProps={{ variant: 'h6' }}
                                    />
                                    <CardContent>
                                        <Grid container item xs={12}>
                                            <Grid xs={8} className={classes.subHeaderGrey}>
                                                <Typography className={classes.textTitle}>{t(`OrderDashboard.Status`)}</Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.subHeaderGrey}>
                                                <Typography className={classes.textTitle} style={{textAlign: 'center'}}>
                                                {t(`OrderDashboard.Total`)}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={8}>
                                                <Typography className={classes.text}>{t(`OrderDashboard.Assigned`)}</Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.dashboardAlign}>
                                                <Typography className={classes.text}>
                                                    {formatNumber(props.dashboardItem.assignet?? 0)}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={8}>
                                                <Typography className={classes.text}>{t(`OrderDashboard.RejectedDocumentation`)}</Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.dashboardAlign}>
                                                <Typography className={classes.text}>
                                                    {formatNumber(props.dashboardItem.rejectedDocumentation?? 0)}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={8}>
                                                <Typography className={classes.text}>{t(`OrderDashboard.Inprocess`)}</Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.dashboardAlign}>
                                                <Typography className={classes.text}>
                                                {formatNumber(props.dashboardItem.inProgress?? 0)}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={8}>
                                                <Typography className={classes.text}>{t(`OrderDashboard.PaidReject`)}</Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.dashboardAlign}>
                                                <Typography className={classes.text}>
                                                    {formatNumber(props.dashboardItem.paidRejected?? 0)}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={8}>
                                            </Grid>
                                            <Grid xs={4} className={classes.dashboardAlign}>
                                                <Typography className={classes.textTitle} style={{borderTop: '1px solid #bdbdbd'}}>
                                                    {formatNumber(props.dashboardItem.total?? 0)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}><br /></Grid>
                </Grid>
            </Container>
            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    dashboardItem: state.OrderReducer.itemDashboard,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(OrderActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OtherTransactionsStyles)(OtherTransactionsDashboard))
